import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Breadcrumb } from '@core/models/breadcrumb/breadcrumb.model';
import { CategoryModel } from '@core/models/categories';
import { GetProductsQuery, ProductReturnModel } from '@core/services/api.service';
import { AppendBrandAction, ResetBrandAction } from '@ngxs-store/breadcrumb-store/breadcrumb.actions';
import { BreadcrumbState } from '@ngxs-store/breadcrumb-store/breadcrumb.state';
import { LoadProductsAction, SelectCategoryAction } from '@ngxs-store/product-store/product.actions';
import { ProductState } from '@ngxs-store/product-store/product.state';
import { StoreSearchTextAction } from '@ngxs-store/search-store/search.actions';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-products-page',
    template: `
  <app-product-list
            [isLoading]="isLoading$ | async"
            [pageNumber]="pageNumber"
            [resultsPerPage]="resultsPerPage"
            [sortBy]="sortBy"
            [sortByDirection]="sortByDirection"
            [brands]="brands$ | async"
            [products]="ProductReturnModel$ | async"
            [productsCategories]="ProductsCategories$ | async"
        ></app-product-list>
  `,

    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchProductsPageComponent implements OnInit {
    @Select(ProductState.getProductsResult) ProductReturnModel$: Observable<ProductReturnModel>;
    @Select(ProductState.getBrands) brands$: Observable<ProductReturnModel[]>;
    @Select(ProductState.getProductsCategoriesResult) ProductsCategories$: Observable<CategoryModel[]>;
    @Select(ProductState.isLoading) isLoading$: Observable<boolean>;
    @Select(BreadcrumbState.getCurrentBrand) currentBrand$: Observable<Breadcrumb>;

    category = '';
    brand = '';
    subCategory = '';
    pageNumber = 1;
    resultsPerPage = 16;
    sortBy = 'Default';
    sortByDirection = 'DESC';
    // routeSub: Subscription;

    getProductsQuery$: GetProductsQuery;
    products$: Observable<ProductReturnModel>;
    currentBrand: string = null;
    searchText = '';

    constructor(
        private store: Store,
        private router: Router,
        private activatedRoute: ActivatedRoute
    ) { }

    ngOnInit() {
        var productCategory = this.router.url;
        this.currentBrand$.subscribe(x => {
            this.currentBrand = x?.text;
            if (this.currentBrand) {
                this.store.dispatch(new AppendBrandAction({ brand: this.currentBrand, url: x.currentUrl }))
            }
        });
        this.activatedRoute.params.subscribe((params) => {
            var searchItem = params.searchText;
            this.getSearchedProducts(searchItem.split('?')[0]);
        });


    }

    getSearchedProducts(searchText: string) {
        this.searchText = searchText;
        this.getProductsQuery$ = new GetProductsQuery({
            pageNumber: 1,
            resultsPerPage: 16,
            sortBy: 'Price',
            sortDirection: 'DESC',
            descriptionFilter: searchText,
            brandFilter: this.activatedRoute.snapshot.queryParamMap.get('brandFilter'),
            categoryFilter: this.activatedRoute.snapshot.queryParamMap.get('categoryFilter'),
            subCategory1Filter: this.activatedRoute.snapshot.queryParamMap.get('subCategory1Filter'),
            subCategory2Filter: '',
            featuredProductsOnly: false,
            newProductsOnly: false,
            inStockOnly: false
        });

        this.store.dispatch(new StoreSearchTextAction({ text: searchText }));
        this.store.dispatch(new LoadProductsAction({ loadProductsQuery: this.getProductsQuery$, updateFilters: true }));
    }

    getPagedProducts() {
        this.store.dispatch(new LoadProductsAction({ loadProductsQuery: this.getProductsQuery$ }));
    }

    getPagedProductsByBrand($event) {
        this.store.dispatch([new LoadProductsAction({ loadProductsQuery: $event }), new AppendBrandAction({ brand: $event.brandFilter, url: this.router.url })]);
    }

    selectCategory(category: CategoryModel) {
        this.store.dispatch(new SelectCategoryAction({ category }))
    }

}

